import { ref } from 'vue';
import { hashCodeLib } from 'shared';
import type { MappedNearestSearch } from 'freedom-shared';

import {
  nearestSearchesApi,
  nearestSearchesLib,
} from '@/entities/nearest-searches';

import { sentryModel } from '@/shared/model';

import { DEFAULT_OW_SEARCHES_RANGE as defaultDatesRange } from './config';

export const useNearestSearches = () => {
  const nearestSearches = ref<MappedNearestSearch[]>([]);
  const isLoading = ref<boolean>(false);

  const init = (searchQuery: string) => {
    isLoading.value = true;

    const selectedSearchDate =
      hashCodeLib.getSearchParams(searchQuery).itineraries[0].date;
    const requestDateRange = nearestSearchesLib.getDateRangeForGetRequest(
      selectedSearchDate,
      defaultDatesRange,
    );

    nearestSearchesApi
      .getNearestSearches(searchQuery, requestDateRange)
      .then(
        data =>
          (nearestSearches.value = nearestSearchesLib.mapSearches(
            data,
            selectedSearchDate,
            defaultDatesRange,
          )),
      )
      .catch(e => {
        sentryModel.captureException(
          sentryModel.getReadableError('ERR_TO_FETCH_NEAREST_SEARCHES_OW', e),
          {
            extra: {
              scope: e.response?.data?.errors[0]?.scope,
              message: e.response?.data?.errors[0]?.message,
            },
          },
        );
        throw e;
      })
      .finally(() => (isLoading.value = false));
  };

  return {
    nearestSearches,
    isLoading,
    init,
  };
};
